import React, { type FC } from "react";
import classes from "./ErrorCard.module.css";
import { type Error } from "./SectionDragCards";

type ErrorProps = {
  error: Error | any;
};

const ErrorCard: FC<ErrorProps> = ({ error }) => {
  return (
    <div className={classes.error_card_wrapper}>
      <div className={classes.error_card}>
        <div className={classes.error_code}>
          <p className={classes.primary_text}>အမှားကုဒ်- </p>
          <p className={classes.primary_text}>{error?.originalStatus}</p>
        </div>
        <div className={classes.error}>
          <p className={classes.error_message}>
            {error?.error || "Something Went Wrong! Refresh the site"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ErrorCard;
